import { render, staticRenderFns } from "./BlockDetailsModal.vue?vue&type=template&id=96cde76a"
import script from "./BlockDetailsModal.vue?vue&type=script&lang=js"
export * from "./BlockDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports